export const getIsLoading = (state) => state.authentication.isApiLoading;
export const getUserProfile = (state) => state.authentication.userInformation;